import SvgIcon from 'material-ui/SvgIcon';
import React from 'react';
/**
 * Created by max on 30/08/2017.
 */
 const Misc = (props) => (
   <SvgIcon {...props}>
    <polygon fill="none" stroke={props.color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" points="
      5.16,3 5.16,21 18.84,21 18.84,3 16.828,3 7.172,3 "/>
    <polyline fill="none" stroke={props.color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" points="
      18.84,16.114 17.04,17.4 14.52,15.682 14.52,11.28 18.84,11.28 "/>
    <path fill="none" stroke={props.color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" d="
      M16.603,3c0,2.585-2.061,4.68-4.603,4.68S7.397,5.585,7.397,3H16.603"/>
    <path fill="none" stroke={props.color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" strokeMiterlimit="10" d="
      M14.479,3c0,1.392-1.11,2.52-2.478,2.52S9.522,4.392,9.522,3H14.479"/>
   </SvgIcon>
);

export default Misc;



// WEBPACK FOOTER //
// ./src/icons/types/Merch.jsx